/// FOURJS_START_COPYRIGHT(D,2014)
/// Property of Four Js*
/// (c) Copyright Four Js 2014, 2026. All Rights Reserved.
/// * Trademark of Four Js Development Tools Europe Ltd
///   in the United States and elsewhere
///
/// This file can be modified by licensees according to the
/// product manual.
/// FOURJS_END_COPYRIGHT

"use strict";

modulum("OnCopyArrayUIBehavior", ["UIBehaviorBase"], function (context, cls) {
  /**
   * Add the possibility of copying a row for any Array like controller
   * @class OnCopyArrayUIBehavior
   * @memberOf classes
   * @extends classes.UIBehaviorBase
   */
  cls.OnCopyArrayUIBehavior = context.oo.Singleton(cls.UIBehaviorBase, function ($super) {
    return /** @lends classes.OnCopyArrayUIBehavior.prototype */ {
      /** @type {string} */
      __name: "OnCopyArrayUIBehavior",
      /**
       * @inheritDoc
       */
      _attachWidget: function (controller, data) {
        if (controller?.getWidget()) {
          data._copyRowHandle = controller.getWidget().when(gbc.constants.widgetEvents.copyRow, this._onCopyRow.bind(this, controller, data));

          data._copyCurrentRowHandle = controller
            .getWidget()
            .when(gbc.constants.widgetEvents.copyCurrentRow, this._onCopyCurrentRow.bind(this, controller, data));

          data._copyCellHandle = controller.getWidget().when(gbc.constants.widgetEvents.copyCell, this._onCopyCell.bind(this, controller, data));

          data._onBuildContextMenuCopyArrayActionsHandle = controller
            .getWidget()
            .when(gbc.constants.widgetEvents.buildContextMenuCopyArrayActions, this._onBuildContextMenuCopyArrayActions.bind(this, controller, data));
        }
      },
      /**
       * @inheritDoc
       */
      _detachWidget: function (controller, data) {
        if (data._copyRowHandle) {
          data._copyRowHandle();
          data._copyRowHandle = null;
        }
        if (data._copyRowCurrentHandle) {
          data._copyRowCurrentHandle();
          data._copyRowCurrentHandle = null;
        }
        if (data._copyCellHandle) {
          data._copyCellHandle();
          data._copyCellHandle = null;
        }
      },

      /**
       * Get the current row from the controller and ask to copy it.
       */
      _onCopyCurrentRow: function (controller, data, gbcEvent, element) {
        const rowIndex = controller.getCurrentRow() - controller.getOffset();
        this._onCopyRow(controller, data, gbcEvent, element, rowIndex);
      },

      /**
       * Use ValueList node to build a child node list to copy. Then send it to the ClipboardService
       */
      _onCopyRow: function (controller, data, gbcEvent, element, rowIndex) {
        if (rowIndex === undefined) {
          const error = new ReferenceError("Impossible to copy row, the rowIndex is not defined. Add it as parameter when emitting the event.");
          context.LogService.warn(error);
          return;
        }
        const anchorNode = controller.getAnchorNode();
        const nodeToCopy = [];
        const valueListNodes = anchorNode.getDescendants("ValueList");
        if (!cls.MathHelper.isInRange(rowIndex, 0, valueListNodes[0].getChildren().length - 1)) {
          const error = new RangeError(
            `Impossible to copy the row ${rowIndex} as it is out of range.\nAccepted range : [0 : ${valueListNodes[0].getChildren().length - 1}]`
          );
          context.LogService.warn(error);
          return;
        }
        for (const valueListNode of valueListNodes) {
          const valueNode = valueListNode.getChildren("Value")[rowIndex];
          if (valueNode) {
            const widgetToCopy = valueNode.getWidget();
            if (widgetToCopy?.isVisible()) {
              nodeToCopy.push(valueNode.getWidget());
            }
          }
        }
        gbc.ClipboardService.copyFromWidgets(controller.getWidget(), nodeToCopy, true).then(null);
      },

      _onCopyCell: function (controller, data, gbcEvent, element, cellWidget) {
        if (cellWidget === undefined) {
          const error = new ReferenceError("Impossible to copy cell, the cell is not defined. Add it as parameter when emitting the event.");
          context.LogService.warn(error);
          return;
        }
        gbc.ClipboardService.copyFromWidget(cellWidget, null, true).then(null);
      },

      _onBuildContextMenuCopyArrayActions(controller, data, gbcEvent, element, contextMenu, sourceWidget) {
        contextMenu.addAction(
          "copyRow",
          gbc.I18NService.t("gwc.contextMenu.copyRow"),
          null,
          null,
          {
            clickCallback: function () {
              contextMenu.hide();
              controller.getWidget().emit(gbc.constants.widgetEvents.copyCurrentRow);
            }
          },
          true
        );

        contextMenu.addAction(
          "copyCell",
          gbc.I18NService.t("gwc.contextMenu.copyCell"),
          null,
          null,
          {
            clickCallback: function () {
              contextMenu.hide();
              controller.getWidget().emit(gbc.constants.widgetEvents.copyCell, sourceWidget);
            }
          },
          true
        );
      }
    };
  });
});
